const ENABLE_DISABLE_PARAMETERS = new Set([
  'proxy_en_dis', 'brao_en_dis', 'temp_en_dis',
  'initial_lock_timer_config', 'display_results_flag'
]);

export const formatDiagnosticParameter = (parameter, value) => {
  const raw = String(value ?? '').trim();
  if (!raw) return 'N/A';
  const name = String(parameter).toLowerCase();
  if ((raw === '0' || raw === '1') && (ENABLE_DISABLE_PARAMETERS.has(name) || name === 'random_test')) {
    const enabled = name === 'random_test' ? raw === '0' : raw === '1';
    return enabled ? 'Enable' : 'Disable';
  }
  return raw;
};
